import React, {useState, useEffect, useContext} from 'react'
import PatientContext from '../../../context/patientContext'
import UserPrefContext from "../../../context/userPrefContext"
import DictionaryContext from '../../../context/dictionaryContext'
import AuthContext from '../../../context/authContext'
import EarQOneChart from './EarQOneChart'
// import TotalScore from '../shared/TotalScore'
import chartClasses from '../../stylesheets/Charts.module.css'

function EarQCharts(props) {
    const dictCtx = useContext(DictionaryContext)
    const visCtx = useContext(PatientContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)
    

    const dict_intake_form_id = dictCtx.dict_intake_form.find(form => form.display_name_short === "earq").id 
    const earQGetAllURL = `${process.env.REACT_APP_SERVER}/api/v1/form_responses/patient/${visCtx.pat_token}`

    const [chartDataSorted, setChartDataSorted] = useState([])
    // const [earQs, setEarQs] = useState([])
    const [x_axis_categories, set_x_axis_categories] = useState([])
    const [dictChartSorted, setDictChartSorted] = useState([])


      useEffect(() => {
        // get data 
        let dict_chart = dictCtx.dict_chart.filter((chart) => chart.group_display_name_short === "earq").sort((a,b) => a.group_id - b.group_id)
        if (props.viewType !== 'full') {
            // limit number of charts on visit page
            dict_chart = dict_chart.slice(0, process.env.REACT_APP_EFACE_VISITPAGE_LIMIT)
        }
        setDictChartSorted(dict_chart)

        // console.log("dictChartSorted", dict_chart)

        const x_categories = dict_chart.map((chart) => {
            return JSON.parse(chart.x_axis_category)
        })
        // console.log("x_categories", x_categories)
        // each element in x_categories is a two-elemnt array; first alement is the name of the chart; second is the name of the corresponding value field in eface data
        set_x_axis_categories(x_categories)

        let ignoreEarQs = false
        const getAllEarQs = async() => {
            try {
                const response = await fetch(earQGetAllURL, {
                    headers: {
                        'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
                        auth: authCtx.authMode,
                    },
  
                })
    
                if (response.status === 200) {
                    if (!ignoreEarQs) {
                        const responseData = await response.json()
                        const data = responseData
                          .filter(rd => rd.dict_intake_form_id === dict_intake_form_id)
                          .map(rd => {
                            const res = rd.results
                              .map(r => {return {[r.scale]: r.score_0_100}})
                              .reduce((obj, item) => {
                                return {...obj, ...item}
                              },{})
                            return {...res, id:rd.id, visit_date: rd.visit_date}
                          })
                        // console.log("chart data", data)
                        // setEarQs(data.sort((a,b) => new Date(a.visit_date) > new Date(b.visit_date) ? 1 : -1))
                        setChartDataSorted(data.sort((a,b) => new Date(a.visit_date) > new Date(b.visit_date) ? 1 : -1))
                    }
                    
                } else {
                    console.log("Failed to get all ear-Qs", response)
                }
            } catch (e) {
                console.log("Failed to get all ear-Qs", e)
            }
    
        }

        if (userPrefCtx.bearerToken !== null && !!props.loaded) {
            getAllEarQs()
        }
        

        return () => {
            ignoreEarQs = true
        }
        //I added the patient context as a dependency so that the the panel can be consistent with the user through the searchbar
    }, [userPrefCtx.bearerToken, props.loaded, dictCtx.dict_chart.length, visCtx.pat_token])



    // useEffect(() => {
    //     // sort the data
    //     // console.log("chart Data Sorted", earQs.sort((a,b) => new Date(a.visit_date) > new Date(b.visit_date) ? 1 : -1))
    //     // setChartDataSorted(earQs.sort((a,b) => new Date(a.visit_date) > new Date(b.visit_date) ? 1 : -1))

    //     // console.log("chart Data", earQs)
    //     setChartDataSorted(earQs)
    // }, [earQs])

    const chartsClicked = () => {
        if (chartDataSorted.length > 0 && props.hasOwnProperty('onClick')) {
            props.onClick()
        }
    }


    return (
        <div height='500' className={`eface-charts ${props.viewType === 'full' ? chartClasses['charts-full']: chartClasses['charts-sm'] }`} 
            onClick={chartsClicked}
        >
            {/* {props.viewType === 'full' && chartDataSorted.length > 0 &&
                <h3 className={chartClasses['charts-center']}>
                    Total Facial Function Score: 
                    <TotalScore 
                        data={chartDataSorted}    
                        property_date_name='eface_date'
                        property_value_name='smile_score'
                        first_or_last='last'
                    />
                </h3>
            } */}
            { dictChartSorted.length > 0 && chartDataSorted.length > 0 && dictChartSorted.map((achart, chart_ix) => {
                    return (
                        <EarQOneChart key={chart_ix}
                            chart={achart} 
                            data={chartDataSorted}
                            x_categories={x_axis_categories[chart_ix]}
                            width={'98%'}
                            height={props.viewType === 'full' ? 350 : 150}
                            viewType={props.viewType}
                        />
                    )
                })
            }

        </div>
    )
}

export default EarQCharts
